import DiffMatchPatch from 'diff-match-patch';
import { createElement } from 'react';
export const diffText = (anchorText, clauseText, options) => {
    const defaultOptions = {
        textOnly: false,
    };
    options = Object.assign(Object.assign({}, defaultOptions), (options || {}));
    if (!anchorText) {
        anchorText = '';
    }
    if (!clauseText) {
        clauseText = '';
    }
    const dmp = new DiffMatchPatch();
    const diffParts = dmp.diff_main(anchorText.replace(/\n/g, ' '), clauseText);
    dmp.diff_cleanupSemantic(diffParts);
    const textParts = [];
    diffParts.forEach((part) => {
        const color = part[0] === DiffMatchPatch.DIFF_INSERT
            ? 'green'
            : part[0] === DiffMatchPatch.DIFF_DELETE ? 'red' : '';
        let elType = 'span';
        if (color === 'red') {
            elType = 's';
        }
        if (options.textOnly) {
            return textParts.push({ text: part[1], type: color });
        }
        return textParts.push(createElement(elType, { className: color, style: { color: color } }, part[1]));
    });
    if (options.textOnly) {
        return textParts;
    }
    return createElement('p', { className: 'clause-diff' }, textParts);
};
